import React, { useState } from "react";
import Modal from "../Modal/Modal";
import "../Card/Card.css";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";

const Card = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "", // Changed from query to message
    option: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submissionError, setSubmissionError] = useState("");

  const cards = [
    { id: 1, image: "typea.webp", ribbon: "4.5-XL BHK(4190 SQ. FT.)" },
    { id: 2, image: "typeb.webp", ribbon: "4.5 BHK(3200 SQ. FT.)" },
    { id: 3, image: "typec.webp", ribbon: "3.5 BHK(2290 SQ. FT.)" },
  ];

  const cards2 = [{ id: 1, image: "aw.webp", ribbon: "UP COMING PROJECT" }];

  const handleImageClick = () => {
    setShowModal(true);
  };

  const hideModal = () => {
    setShowModal(false);
  };

  const validate = (name, value) => {
    let errors = { ...formErrors };

    switch (name) {
      case "name":
        errors.name = /^[A-Za-z\s]+$/.test(value)
          ? ""
          : "Name should contain only alphabets.";
        break;
      case "email":
        errors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? ""
          : "Invalid email address.";
        break;
      case "mobile":
        errors.mobile = /^\d{10}$/.test(value)
          ? ""
          : "Mobile number should be 10 digits.";
        break;
      case "option":
        errors.option = value ? "" : "Please select an option.";
        break;
      case "message": // Changed from query to message
        if (!value.trim()) {
          errors.message = "Message is required"; // Changed error message
        } else if (value.length < 3) {
          errors.message = "Message should be at least 15 characters long"; // Changed error message
        } else {
          errors.message = "";
        }
        break;
      default:
        break;
    }

    setFormErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    validate(name, value); // Perform validation on each input change
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Perform validation before submission
    Object.keys(formValues).forEach((key) => validate(key, formValues[key]));

    if (Object.keys(formErrors).some((key) => formErrors[key] !== "")) {
      return;
    }

    setSubmitting(true);

    // Prepare template parameters including bind_message
    const templateParams = {
      ...formValues,
      bind_message: "Ace Hanei", // Added bind_message with the required value
    };

    // Updated to use new EmailJS credentials
    emailjs
      .send(
        "service_cn3p6bh",
        "template_njp17vm",
        templateParams,
        "M9d0B5RLs-0It1XRj",
      )
      .then(
        (result) => {
          setSubmitting(false);
          Swal.fire({
            title: "Thank You!",
            text: "Your message has been submitted successfully.", // Updated text
            icon: "success",
            confirmButtonText: "OK",
          });
          setShowModal(false);
          // Reset form values
          setFormValues({
            name: "",
            email: "",
            mobile: "",
            message: "", // Reset message field
            option: "",
          });
          setFormErrors({});
          navigate("/thankyou");
        },
        (error) => {
          setSubmitting(false);
          setSubmissionError("An error occurred. Please try again later.");
          Swal.fire({
            title: "Error!",
            text: "An error occurred while submitting your message. Please try again later.", // Updated text
            icon: "error",
            confirmButtonText: "OK",
          });
        },
      );
  };

  return (
    <>
      <div className="card-full2">
        <h2>
          <strong>ACE Hanei</strong> Layout
        </h2>
        <div className="card-section2">
          <div className="card-grid2">
            {cards2.map((card2) => (
              <div key={card2.id} className="card2">
                <img
                  src={card2.image}
                  alt={`Card2 ${card2.id}`}
                  className="card-image2"
                  onClick={handleImageClick}
                />
                <div className="ribbon2">{card2.ribbon}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="card-full">
        <h2>Our Flat Sizes</h2>
        <div className="card-section">
          <div className="card-grid">
            {cards.map((card) => (
              <div key={card.id} className="card">
                <img
                  src={card.image}
                  alt={`Card ${card.id}`}
                  className="card-image"
                  onClick={handleImageClick}
                />
                <div className="ribbon">{card.ribbon}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Modal show={showModal} handleClose={hideModal}>
        <h2 className="modal-heading">Get More Details</h2>
        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formValues.name}
              onChange={handleChange}
              className={`input ${formErrors.name ? "invalid" : ""}`}
              required
            />
            {formErrors.name && (
              <span className="error">{formErrors.name}</span>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formValues.email}
              onChange={handleChange}
              className={`input ${formErrors.email ? "invalid" : ""}`}
              required
            />
            {formErrors.email && (
              <span className="error">{formErrors.email}</span>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="mobile">Mobile:</label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              value={formValues.mobile}
              onChange={handleChange}
              className={`input ${formErrors.mobile ? "invalid" : ""}`}
              required
            />
            {formErrors.mobile && (
              <span className="error">{formErrors.mobile}</span>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="option">Select Flat Option:</label>
            <select
              id="option"
              name="option"
              value={formValues.option}
              onChange={handleChange}
              className={`input ${formErrors.option ? "invalid" : ""}`}
              required
            >
              <option value="">-Select-</option>
              <option value="4.5-XL BHK(4190 SQ. FT.)">
                4.5-XL BHK(4190 SQ. FT.)
              </option>
              <option value="4.5 BHK(3200 SQ. FT.)">
                4.5 BHK(3200 SQ. FT.)
              </option>
              <option value="3.5 BHK(2290 SQ. FT.)">
                3.5 BHK(2290 SQ. FT.)
              </option>
            </select>
            {formErrors.option && (
              <span className="error">{formErrors.option}</span>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="message">Your Message:</label>{" "}
            {/* Changed from Query to Message */}
            <textarea
              id="message"
              name="message"
              required
              value={formValues.message}
              onChange={handleChange}
              className={`input ${formErrors.message ? "invalid" : ""}`} // Updated from formErrors.query
              rows="4"
            />
            {formErrors.message && (
              <span className="error">{formErrors.message}</span>
            )}{" "}
            {/* Updated from formErrors.query */}
          </div>
          <div className="butt-f">
            <button
              className="button-3"
              type="submit"
              disabled={
                submitting ||
                Object.keys(formErrors).some((key) => formErrors[key] !== "")
              }
            >
              {submitting ? "Submitting..." : "SUBMIT"}
            </button>
          </div>
          {submissionError && (
            <p className="submission-error">{submissionError}</p>
          )}
        </form>
      </Modal>
    </>
  );
};

export default Card;
